import type { SerializedError } from '@reduxjs/toolkit';

export class ThunkRejectedError extends Error {
  readonly serialized: SerializedError;
  readonly code?: string;

  constructor(serialized: SerializedError, actionType: string) {
    super(serialized.message ?? actionType);
    this.name = serialized.name ?? 'ThunkRejectedError';
    this.serialized = serialized;
    this.code = serialized.code;
    if (serialized.stack) {
      this.stack = serialized.stack;
    }
  }
}
